import angular from 'angular';
import { MeurhEscalaSchedulerService } from '../escala.scheduler.service';
import { MeurhEscalaSchedulerColaboradoresService } from '../escala.scheduler.colaboradores.service';
import { ListagemService } from '../../../../shared/services/listagem.service';
import { SchedulerStatic } from '../../../../shared/components/dhtmlx-scheduler/dhtmlxscheduler';
import { ITrabalhador } from '../../../Trabalhadores/models/trabalhador.model';
import { IFiltroListagemEscala } from '../models/escala.filtros.model';
import { Empresa, Estabelecimento } from '../../../../core/usuario/models/usuario-model';

export class MeurhEscalaFiltrosController {

    static $inject = [
        '$scope',
        '$rootScope',
        'MeurhEscalaSchedulerService',
        'MeurhEscalaSchedulerColaboradoresService',
        'ListagemService'
    ];

    public schedulerEventos: SchedulerStatic; // instancia do calendario
    public colaboradores: ITrabalhador[];
    public filtros: IFiltroListagemEscala = {
        colaborador: {
            nome: 'Colaboradores',
            valor: []
        },
        situacao: {
            nome: 'Situação do colaborador',
            valor: ''
        },
        tipo: {
            nome: 'Tipo de colaborador',
            valor: null
        },
        departamento: {
            nome: 'Departamentos',
            valor: null
        },
        cargo: {
            nome: 'Cargos',
            valor: null
        },
        lotacao: {
            nome: 'Lotações',
            valor: null
        },
        horario: {
            nome: 'Horários',
            valor: null
        },
        grupodeponto: {
            nome: 'Grupos de ponto',
            valor: null
        },
        tipohorario: {
            nome: 'Tipo de horário',
            valor: false
        }
    };

    public filtrosVisibilidade: { empresa: string, estabelecimento: string };
    public empresas: Empresa[];
    public estabelecimentos: Estabelecimento[];
    public listagemPermissao: string[] = ['visualizar_calendario'];
    public permissaoGrupoEmpresarial = false;

    constructor (
		public $scope: angular.IScope,
        public $rootScope: angular.IRootScopeService & {
            liberadoTela: (arg: string) => boolean,
            temPermissaoGrupoEmpresarial: (permissoes: string[], grupo: string) => boolean,
            session: any,
            nsjGlobals: any
        },
        public MeurhEscalaSchedulerService: MeurhEscalaSchedulerService,
        public MeurhEscalaSchedulerColaboradoresService: MeurhEscalaSchedulerColaboradoresService,
        public ListagemService: ListagemService,
	) {
        this.permissaoGrupoEmpresarial = $rootScope.temPermissaoGrupoEmpresarial(
            this.listagemPermissao,
            $rootScope.nsjGlobals.a.grupoempresarial
        );

        this.MeurhEscalaSchedulerColaboradoresService.filtros = this.filtros;

        $scope.$on('update_filtro_listagem_escala', () => {
            this.filtraListagem();
        });

        // verifica filtro
        $scope.$watch('$ctrl.filtros', (newValues: IFiltroListagemEscala[], oldValues: IFiltroListagemEscala[]) => {
            if (newValues !== oldValues) {
                this.MeurhEscalaSchedulerColaboradoresService.filtros = this.filtros;
                this.filtraListagem();
			}
        }, true);

        $scope.$watch('$ctrl.filtros.tipohorario.valor', (newValues: boolean | null, oldValues: boolean | null) => {
            if (newValues !== oldValues) {
                this.setHorariosConstructor(newValues ?? false);
			}
        }, true);
    }

    $onInit() {
        this.montaListagemVisibilidade();
    }

    montaListagemVisibilidade() {
        this.empresas = this.ListagemService.montaEmpresas(this.$rootScope.nsjGlobals.a.grupoempresarial, this.listagemPermissao);
        this.estabelecimentos = this.ListagemService.montaEstabelecimentos(this.filtrosVisibilidade.empresa, this.empresas, this.listagemPermissao);
    }

    mudaEstabelecimentos() {
        this.estabelecimentos = this.filtrosVisibilidade.empresa ? this.ListagemService.montaEstabelecimentos(this.filtrosVisibilidade.empresa, this.empresas, this.listagemPermissao) : [];
        this.filtrosVisibilidade.estabelecimento = '';
        this.filtraEmpresaEstabelecimento();
    }

    filtraEmpresaEstabelecimento() {
        this.limpaFiltros();
        this.$rootScope.$broadcast('departamento_refresh', this.filtrosVisibilidade);
        this.$rootScope.$broadcast('cargo_refresh', this.filtrosVisibilidade);
        this.$rootScope.$broadcast('horario_refresh', this.filtrosVisibilidade);
        this.$rootScope.$broadcast('lotacao_refresh', this.filtrosVisibilidade);
        this.$rootScope.$broadcast('grupo_refresh', this.filtrosVisibilidade);
        this.$rootScope.$broadcast('colaboradores_refresh');
    }

    limpaFiltros() {
        Object.keys(this.filtros).forEach((key) => {
            Array.isArray(this.filtros[key].valor) ? this.filtros[key].valor = [] : this.filtros[key].valor = null;
        });
    }

    filtraListagem() {
        this.MeurhEscalaSchedulerColaboradoresService.currentPage = 1;
        this.MeurhEscalaSchedulerService.atualizaListagem(this.schedulerEventos);
	}

    private setHorariosConstructor(apenasEscala: boolean = false) {
        this.$rootScope.$broadcast('horario_refresh', {
            ...this.filtrosVisibilidade,
            ...(apenasEscala && { apenasEscala })
        });
    }
}
